import React from 'react';
import { createUseStyles } from 'react-jss';
import { useStorage } from '../../hooks/use-storage';
import { layoutDefaults } from '../../utils/layout-defaults';
import { parseDividerBackgroundGradient } from '../../utils/manager/layout-manager';

// const animation = 'animate__animated animate__fadeIn';

function ItemDivider({ className, style }) {
  const { menuLayout } = useStorage();
  const classes = useStyles(menuLayout);

  return (
    <div className={className}>
      <div className={classes.divider} style={style} />
    </div>
  );
}

const useStyles = createUseStyles({
  container: {},
  divider: {
    // position: 'absolute',
    height: '1px',
    marginLeft: layoutDefaults.mainHorizontalMargin,
    marginRight: layoutDefaults.mainHorizontalMargin,
    backgroundImage: (layout) =>
      layout != null
        ? `linear-gradient(to right, ${parseDividerBackgroundGradient(
            layout
          ).join(', ')})`
        : '',
  },
});

export { ItemDivider };
